module.exports = __webpack_public_path__ + "img/robot.d51535d9.svg";